export function debounce<T extends Function>(func: T, wait: number, immediate = false): T {
    let timeout: number;

    const res = function (this: any) {
        let that = this;
        let args: any[] = [];

        for (let i = 0; i < arguments.length; i++) {
            args.push(arguments[i]);
        }

        const later = () => {
            timeout = 0;
            if (!immediate) {
                func.apply(that, args);
            }
        };

        let callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait) as any;

        if (callNow) {
            func.apply(that, args);
        }
    };

    return res as any;
}

export interface DebounceSettings {
    immediate?: boolean;
    autobind?: boolean;
}

export function debounceMethod(wait: number, { autobind, immediate }: DebounceSettings = {}) {
    return function (target: any, propKey: string): TypedPropertyDescriptor<any> {
        const func = target[propKey];

        return {
            get() {
                let debFunc = debounce(func, wait, immediate);

                if (autobind) {
                    debFunc = debFunc.bind(this);
                }

                Object.defineProperty(this, propKey, {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: debFunc
                });

                return debFunc;
            }
        };
    };
}
